import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { RadioButton } from 'primereact/radiobutton';
import { FileUpload } from 'primereact/fileupload';
import { visualizarDocumento } from '../../services/empleado/empleadoDocumentoService';
import SelectorUbicacion from './SelectorUbicacion';
import CapturaFotosEmpleado from './CapturaFotosEmpleado';

/*
RECARGA DE IMAGENES
*/
const FotoThumbnail = ({ id, descripcion }) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let objectUrl = null;
        const cargarImagen = async () => {
            try {
                // Usamos el MISMO servicio que usas para el botón "Ver"
                // Esto descarga los bits de la imagen de forma segura
                const blob = await visualizarDocumento(id);
                if (blob) {
                    objectUrl = URL.createObjectURL(blob);
                    setImageSrc(objectUrl);
                }
            } catch (error) {
                console.error('Error cargando thumb:', error);
            } finally {
                setLoading(false);
            }
        };

        if (id) cargarImagen();

        // Limpieza de memoria cuando el componente se desmonta
        return () => {
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [id]);

    // Renderizado condicional
    if (loading) return <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.5rem' }}></i>;
    if (!imageSrc) return <i className="pi pi-image text-400" style={{ fontSize: '2rem' }}></i>;

    return (
        <img
            src={imageSrc}
            alt={descripcion}
            className="shadow-2 border-round cursor-pointer"
            style={{ width: '60px', height: '60px', objectFit: 'cover' }}
            // Opcional: Si haces click, se abre en grande usando la URL que ya generamos
            onClick={() => window.open(imageSrc, '_blank')}
        />
    );
};

export default function DialogosEmpleado({
    modals,
    toggleModal,
    handleChange,
    formData,

    // Props Teléfonos
    // --- PROPS TELÉFONOS (Asegúrate de tener todas estas una sola vez) ---
    phones,
    openNewPhone,
    openEditPhone,
    deletePhone,
    handleSetPrincipalPhone,
    phoneDialog,
    setPhoneDialog,
    phoneLoading,

    phoneData, // <--- El objeto de datos
    setPhoneData, // <--- El actualizador (para el dropdown)
    savePhone,
    submitted,

    // Props Configuración
    handleAddConfig,

    // Props Licencias
    licencias,
    openNewLicencia,
    saveLicencia,
    deleteLicencia,
    licenciaData,
    onLicenciaChange,
    licenciaDialog,
    setLicenciaDialog,
    setLicenciaFile,
    openEditLicencia,
    licenciaLoading,
    //guardarLicencias,
    guardaLicencia,

    // Props Libretas
    libretas,
    openNewLibreta,
    saveLibreta,
    deleteLibreta,
    libretaData,
    onLibretaChange,
    libretaDialog,
    setLibretaDialog,
    setLibretaFile,
    libretaLoading,
    guardaLibreta,
    procLibreta,

    // Props Cuentas
    accounts,
    openNewAccount,
    openEditAccount,
    saveAccount,
    deleteAccount,
    accountData,
    setAccountData,
    handleSetPrincipalAccount,
    listas,
    accountDialog,
    setAccountDialog,
    accountLoading,

    // Props Familiares
    familiares,
    openNewFamiliar,
    openEditFamiliar,
    saveFamiliar,
    deleteFamiliar,
    familiarData,
    setFamiliarData,
    familyDialog,
    setFamilyDialog,
    familiarLoading,

    //Educación
    educacionData,
    setEducacionData,
    saveEducacion,
    setEducacionFile,
    educacionList,
    educacionDialog,
    setEducacionDialog,
    openNewEducacion,
    deleteEducacion,
    educacionLoading,
    guardaEducacion,
    guardandoEdu,

    // Historial
    historialData,
    setHistorialData,
    historialDialog,
    setHistorialDialog,

    //otros docs
    saveOtrosDocs,
    guardaOtrosDocs,
    otrosDocsData,
    otrosDocsDialog,
    setOtrosDocsDialog,
    deleteOtrosDocs,
    otrosDocsList,
    setOtrosDocsFile,
    setOtrosDocsData,
    openEditOtrosDocs,
    openNewOtrosDocs,
    otrosDocsLoading,
    procesaOtrosDocs,

    //ubicacion
    ubicacionData,
    setUbicacionData,
    ubicacionDialog,
    setUbicacionDialog,
    saveUbicacion,
    ubicacionLoading,

    openNewHistorial,
    deleteHistorial,
    historialList,
    setHistorialFile,
    saveHistorial,
    historialLoading,
    guardaHistorial,
    grabaHistorial,

    openEditEducacion,
    openEditHistorial,
    openEditLibreta,

    deleteFoto,
    addFotoDialog,
    openNewFoto,
    setAddFotoDialog,
    fotosDialog,
    setFotosDialog,
    fotosList,
    fotosLoading,
    fotoData,
    setFotoData,
    setFotoFile,
    saveFoto,

    experienciaData,
    experienciaDialog,
    setExperienciaDialog,
    setExperienciaData,
    saveExperiencia,
    experienciaLoading
}) {
    const [visorVisible, setVisorVisible] = useState(false);
    const [visorContent, setVisorContent] = useState(null);
    const [visorTitle, setVisorTitle] = useState('');
    const [visorType, setVisorType] = useState(null);

    const hideVisor = () => {
        setVisorVisible(false);
        // Limpiamos memoria tras cerrar
        setTimeout(() => {
            if (visorContent) {
                URL.revokeObjectURL(visorContent);
                setVisorContent(null);
            }
        }, 300);
    };

    const categoriaBodyTemplate = (rowData) => {
        // Buscamos el ID en la lista de categoriasLicencia que ya tienes cargada
        const cat = listas.categoriasLicencia.find(
            (c) => c.configuracionDetId === rowData.categoria
        );
        return cat ? cat.nombre : 'Cargando...';
    };

    const handleDescargarDocumento = async (rowData) => {
        try {
            // 1. Obtenemos el archivo (Blob)
            const blob = await visualizarDocumento(rowData.id);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            // 2. Determinamos la extensión
            let extension = '';

            // A) Intentamos sacarla de la URL original si existe (ej: "foto.jpg")
            if (rowData.archivoUrl) {
                const partes = rowData.archivoUrl.split('.');
                if (partes.length > 1) {
                    extension = partes.pop().toLowerCase();
                    // Limpieza básica por si la URL tiene parámetros extra
                    if (extension.length > 4) extension = '';
                }
            }

            // B) Si no hay extensión en la URL, la sacamos del tipo de archivo (MIME Type)
            if (!extension) {
                if (blob.type === 'application/pdf') extension = 'pdf';
                else if (blob.type === 'image/jpeg') extension = 'jpg';
                else if (blob.type === 'image/png') extension = 'png';
                else if (blob.type.includes('word')) extension = 'docx';
                else if (blob.type.includes('sheet') || blob.type.includes('excel'))
                    extension = 'xlsx';
                else extension = 'dat'; // Binario genérico
            }

            // 3. Armamos el nombre final
            // Usamos 'nombreArchivo' si viene del backend, o generamos uno genérico con la extensión detectada
            let nombreFinal = rowData.nombreArchivo || `documento_${rowData.id}`;

            // Si el nombre no tiene punto, le pegamos la extensión que encontramos
            if (nombreFinal.indexOf('.') === -1 && extension) {
                nombreFinal = `${nombreFinal}.${extension}`;
            }

            link.setAttribute('download', nombreFinal);

            // 4. Descarga
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error al descargar:', error);
            // Puedes usar toast si lo prefieres: toast.current.show(...)
            alert('No se pudo descargar el archivo.');
        }
    };

    const handleVerDocumento = async (rowData) => {
        //console.log ('PARA VER DOCUMENTO...: ', rowData)
        try {
            // 1. Obtenemos el archivo
            const blob = await visualizarDocumento(rowData.id);
            if (!blob) {
                alert('El archivo no tiene contenido.');
                return;
            }

            // 2. Detectamos tipo y nombre
            let tipoArchivo = blob.type;
            const nombreOriginal = (
                rowData.nombreArchivo ||
                rowData.archivoUrl ||
                ''
            ).toLowerCase();

            // Corrección de tipos si el backend manda genérico
            if (!tipoArchivo || tipoArchivo === 'application/octet-stream') {
                if (nombreOriginal.endsWith('.pdf')) tipoArchivo = 'application/pdf';
                else if (nombreOriginal.match(/\.(jpg|jpeg|png|gif|webp)$/))
                    tipoArchivo = 'image/jpeg';
                else if (nombreOriginal.includes('.doc')) tipoArchivo = 'application/msword';
                else if (nombreOriginal.includes('.xls')) tipoArchivo = 'application/vnd.ms-excel';
            }

            const fileURL = URL.createObjectURL(blob);

            // --- CASO 1: IMÁGENES (Modal) ---
            if (tipoArchivo && tipoArchivo.startsWith('image/')) {
                setVisorContent(fileURL);
                setVisorType(tipoArchivo);
                setVisorTitle(rowData.descripcion || rowData.nombreArchivo || 'Visualización');
                setVisorVisible(true);
            }

            // --- CASO 2: PDF (Pestaña Nueva) ---
            else if (tipoArchivo === 'application/pdf') {
                // Intentamos abrir pestaña nueva
                const pdfWindow = window.open(fileURL, '_blank');

                // Si el navegador bloquea la pestaña o está configurado para descargar todo,
                // NO podemos cambiar el nombre del UUID aquí lamentablemente (limitación del navegador).
                // Pero si el usuario tiene configurado "Abrir PDFs", se verá bien.
                if (!pdfWindow) {
                    alert('Por favor habilite las ventanas emergentes para ver el PDF.');
                }
            }

            // --- CASO 3: OFFICE Y OTROS (Descarga con Nombre Correcto) ---
            else {
                // Aquí es donde arreglamos el problema del UUID para Words/Excel
                const link = document.createElement('a');
                link.href = fileURL;

                // Calculamos el nombre correcto
                let nombreFinal = rowData.nombreArchivo || `documento_${rowData.id}`;

                // Si falta la extensión, se la pegamos
                if (nombreFinal.indexOf('.') === -1) {
                    if (tipoArchivo.includes('word') || tipoArchivo.includes('officedocument'))
                        nombreFinal += '.docx';
                    else if (tipoArchivo.includes('sheet') || tipoArchivo.includes('excel'))
                        nombreFinal += '.xlsx';
                    else if (tipoArchivo.includes('pdf')) nombreFinal += '.pdf';
                    else nombreFinal += '.dat';
                }

                // ESTA LÍNEA ES LA QUE EVITA EL UUID:
                link.download = nombreFinal;

                link.click();
            }
        } catch (error) {
            console.error('Error visualizando documento:', error);
            alert('No se pudo cargar el documento.');
        }
    };

    const archivoBodyTemplate = (rowData) => {
        if (!rowData.id) return null;

        // Función expandida para detectar archivos que el navegador puede "abrir"
        const esVisualizable = () => {
            const nombre = (rowData.archivoUrl || rowData.nombreArchivo || '').toLowerCase();
            // Incluimos imágenes y PDFs
            return /\.(jpeg|jpg|gif|png|webp|bmp|pdf)$/i.test(nombre);
        };

        return (
            <div className="flex gap-2 justify-content-center">
                {/* Ahora el botón "Ver" aparece para Imágenes Y para PDFs */}
                {esVisualizable() && (
                    <Button
                        icon="pi pi-eye"
                        className="p-button-rounded p-button-text p-button-info"
                        tooltip="Visualizar"
                        onClick={() => handleVerDocumento(rowData)}
                    />
                )}

                <Button
                    icon="pi pi-download"
                    className="p-button-rounded p-button-text p-button-success"
                    tooltip="Descargar"
                    onClick={() => handleDescargarDocumento(rowData)}
                />
            </div>
        );
    };

    // Templates de Tablas
    const bancoTemplate = (rowData) => {
        const b = listas.bancos.find((x) => x.configuracionDetId === rowData.banco);
        return b ? b.nombre : '...';
    };
    const tipoCuentaTemplate = (rowData) => {
        const t = listas.tiposCuenta.find((x) => x.configuracionDetId === rowData.tipoCuenta);
        return t ? t.nombre : '...';
    };

    // Templates Familiares
    const parentescoTemplate = (rowData) => {
        // Usamos == para que compare correctamente si un ID es String y el otro Number
        const x = listas.parentescos.find((i) => i.configuracionDetId == rowData.parentesco);
        return x ? x.nombre : '...';
    };
    const tipoFamTemplate = (rowData) => {
        const x = listas.tiposFamilia.find((i) => i.configuracionDetId === rowData.tipoFamiliar);
        return x ? x.nombre : '...';
    };
    const tipoDocFamTemplate = (rowData) => {
        const x = listas.tiposDocumento.find((i) => i.configuracionDetId === rowData.tipoDoc);
        return x ? x.nombre : '...';
    };

    const tipoTelefonoTemplate = (rowData) => {
        const t = listas.tiposTelefono.find((x) => x.configuracionDetId === rowData.tipo);
        return t ? t.nombre : '...';
    };

    const fechaFamTemplate = (r) => {
        // Validación estricta para evitar el error "Invalid Date" en pantalla
        if (
            r.fechaNacimiento &&
            r.fechaNacimiento instanceof Date &&
            !isNaN(r.fechaNacimiento.getTime())
        ) {
            return r.fechaNacimiento.toLocaleDateString();
        }
        return '';
    };

    const otrosDocsCatTemplate = (rowData) => {
        // Usamos '==' para que funcione con string o number
        const cat = listas.tiposOtrosDocs.find((c) => c.configuracionDetId == rowData.categoria_id);
        return cat ? cat.nombre : '';
    };

    const fotoPreviewTemplate = (rowData) => {
        // Si no hay URL, mostramos un icono gris
        if (!rowData.archivoUrl) {
            return <i className="pi pi-image text-400" style={{ fontSize: '2rem' }}></i>;
        }

        // --- SOLUCIÓN: Retornar la imagen ---
        return (
            <img
                src={rowData.archivoUrl}
                alt={rowData.descripcion}
                className="shadow-2 border-round"
                style={{ width: '60px', height: '60px', objectFit: 'cover' }}
                // Fallback por si la URL está rota
                onError={(e) =>
                    (e.target.src =
                        'https://www.primefaces.org/cdn/primereact/images/placeholder.png')
                }
            />
        );
    };

    const principalAccountTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                <RadioButton
                    checked={rowData.esPrincipal}
                    onChange={() => handleSetPrincipalAccount(rowData)}
                    name="radioCuentaPrincipal" // Agrupa los radios visualmente
                    aria-label="Marcar como cuenta principal"
                />
            </div>
        );
    };

    const principalPhoneTemplate = (rowData) => {
        return (
            <div className="flex justify-content-center">
                <RadioButton
                    // 'principal' es el nombre del campo que mapeamos en goToEdit
                    checked={rowData.principal === true}
                    onChange={() => handleSetPrincipalPhone(rowData)}
                    name="radioTelefonoPrincipal"
                    aria-label="Marcar como principal"
                />
            </div>
        );
    };

    //**********  ADICIONES BEGIN
    const fotosCamaraLicencia = (fotoCamara) => {
        setLicenciaFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, fotoCamara];
        });
    };

    const fotosUpoladLicencia = (evt) => {
        setLicenciaFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, ...evt.files];
        });
    };

    const fotosCamaraLibreta = (fotoCamara) => {
        setLibretaFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, fotoCamara];
        });
    };

    const fotosUploadLibreta = (evt) => {
        setLibretaFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, ...evt.files];
        });
    };

    const fotosCamaraEducacion = (fotoCamara) => {
        setEducacionFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, fotoCamara];
        });
    };

    const fotosUploadEducacion = (evt) => {
        setEducacionFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, ...evt.files];
        });
    };

    const fotosCamaraHistorial = (fotoCamara) => {
        setHistorialFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, fotoCamara];
        });
    };

    const fotosUploadHistorial = (evt) => {
        setHistorialFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, ...evt.files];
        });
    };

    const fotosCamaraOtrosDocs = (fotoCamara) => {
        setOtrosDocsFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, fotoCamara];
        });
    };

    const fotosUploadOtrosDocs = (evt) => {
        setOtrosDocsFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, ...evt.files];
        });
    };

    const fotosCamaraFotos = (fotoCamara) => {
        setFotoFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, fotoCamara];
        });
    };

    const fotosUploadFotos = (evt) => {
        setFotoFile((prev) => {
            const historial = Array.isArray(prev) ? prev : [];
            return [...historial, ...evt.files];
        });
    };

    //**********  ADICIONES END

    return (
        <>
            {/* 1. MAPA */}
            <Dialog
                header="Seleccionar Ubicación GPS"
                visible={modals.mapa}
                style={{ width: '800px' }}
                onHide={() => toggleModal('mapa', false)}
                modal
                maximizable
                className="p-fluid"
            >
                {/* Renderizado condicional para seguridad */}
                {formData && (
                    <SelectorUbicacion
                        coordenadaInicial={formData.ubicacionGPS}
                        onConfirmar={(coordString) => {
                            // Actualizamos el formulario principal
                            handleChange('ubicacionGPS', coordString);
                            // Cerramos el modal
                            toggleModal('mapa', false);
                        }}
                        onCancelar={() => toggleModal('mapa', false)}
                    />
                )}
            </Dialog>
            <Dialog
                // USAR ?.id PARA EVITAR EL CRASH
                header={ubicacionData?.id ? 'Editar Ubicación' : 'Nueva Ubicación'}
                visible={ubicacionDialog}
                style={{ width: '850px' }}
                modal
                onHide={() => setUbicacionDialog(false)}
            >
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label className="font-bold">Nombre Ubicación (Ej: Casa, Oficina)</label>
                        <InputText
                            value={ubicacionData?.nombre || ''}
                            onChange={(e) =>
                                setUbicacionData({ ...ubicacionData, nombre: e.target.value })
                            }
                            placeholder="Nombre descriptivo"
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label className="font-bold">Referencia / Descripción Corta</label>
                        <InputText
                            value={ubicacionData?.descripcion || ''}
                            onChange={(e) =>
                                setUbicacionData({ ...ubicacionData, descripcion: e.target.value })
                            }
                        />
                    </div>

                    {/* MAPA E INPUT DE COORDENADAS (El componente antiguo que te sirve) */}
                    <div className="col-12 mb-3">
                        <label className="font-bold block mb-2">
                            Seleccione en el mapa o pegue las coordenadas:
                        </label>
                        <SelectorUbicacion
                            coordenadaInicial={ubicacionData?.ubicacionGps}
                            onConfirmar={(coords) => {
                                // Solo actualizamos el estado local, el guardado real es con el botón de abajo
                                setUbicacionData({ ...ubicacionData, ubicacionGps: coords });
                            }}
                            onCancelar={() => setUbicacionDialog(false)}
                        />
                    </div>

                    <div className="col-12 flex justify-content-end gap-2">
                        <Button
                            label="Confirmar y Guardar"
                            icon="pi pi-save"
                            className="p-button-primary shadow-2"
                            onClick={saveUbicacion} // Llama a la lógica del hook que usa axios
                            loading={ubicacionLoading}
                        />
                    </div>
                </div>
            </Dialog>

            {/* 2. LICENCIAS */}
            <Dialog
                header="Licencias de Conducir"
                visible={modals.licencia}
                style={{ width: '850px' }}
                onHide={() => toggleModal('licencia', false)}
            >
                <div className="flex justify-content-end mb-3">
                    <Button
                        label="Nuevo"
                        icon="pi pi-plus"
                        className="p-button-primary"
                        onClick={openNewLicencia}
                    />
                </div>

                <DataTable
                    value={licencias}
                    size="small"
                    showGridlines
                    emptyMessage="No hay licencias registradas."
                >
                    {/* 1. CATEGORÍA (Muestra Nombre) */}
                    <Column
                        header="Categoría"
                        body={categoriaBodyTemplate}
                        style={{ width: '20%' }}
                    />

                    {/* 2. NÚMERO */}
                    <Column field="numero" header="Número" />

                    {/* 3. FECHAS (Formateadas) */}
                    <Column
                        field="fechaEmision"
                        header="Emisión"
                        body={(r) =>
                            r.fechaEmision ? new Date(r.fechaEmision).toLocaleDateString() : ''
                        }
                    />

                    <Column
                        field="fechaVencimiento"
                        header="Vencimiento"
                        body={(r) =>
                            r.fechaVencimiento
                                ? new Date(r.fechaVencimiento).toLocaleDateString()
                                : ''
                        }
                    />

                    <Column
                        header="Archivo"
                        body={archivoBodyTemplate}
                        style={{ width: '80px', textAlign: 'center' }}
                    />

                    {/* 5. ACCIONES (EDITAR /BORRAR) */}
                    <Column
                        header="Acciones"
                        body={(r) => (
                            <div className="flex gap-2 justify-content-center">
                                <Button
                                    icon="pi pi-pencil"
                                    className="p-button-rounded p-button-text p-button-warning"
                                    onClick={() => {
                                        openEditLicencia(r);
                                    }}
                                />
                                <Button
                                    icon="pi pi-trash"
                                    className="p-button-rounded p-button-text p-button-danger"
                                    onClick={() => deleteLicencia(r)}
                                />
                            </div>
                        )}
                        style={{ width: '80px', textAlign: 'center' }}
                    />
                </DataTable>
            </Dialog>

            {/* 2.1 FORM LICENCIA */}
            <Dialog
                header={licenciaData.id ? 'Editar Licencia' : 'Nueva Licencia'}
                visible={licenciaDialog}
                style={{ width: '500px' }}
                modal
                onHide={() => setLicenciaDialog(false)}
            >
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label>Categoría</label>
                        <div className="p-inputgroup">
                            <Dropdown
                                value={licenciaData.categoriaId}
                                // CAMBIO: Usar listas.categoriasLicencia
                                options={listas.categoriasLicencia}
                                optionLabel="nombre"
                                optionValue="configuracionDetId"
                                dataKey="configuracionDetId"
                                onChange={(e) => onLicenciaChange(e.value, 'categoriaId')}
                                placeholder="Seleccione"
                            />
                            <Button
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={() => handleAddConfig('CATEGORIA_LICENCIA')}
                            />
                        </div>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label>Número</label>
                        <InputText
                            value={licenciaData.numero}
                            onChange={(e) => onLicenciaChange(e.target.value, 'numero')}
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label>Fecha Emisión</label>
                        <Calendar
                            value={licenciaData.fechaEmision}
                            onChange={(e) => onLicenciaChange(e.value, 'fechaEmision')}
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label>Fecha Vencimiento</label>
                        <Calendar
                            value={licenciaData.fechaVencimiento}
                            onChange={(e) => onLicenciaChange(e.value, 'fechaVencimiento')}
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>

                    {/* 1. ADJUNTAR EN LICENCIA */}
                    <div className="col-6 mt-2">
                        <FileUpload
                            mode="basic"
                            name="archivos"
                            auto={false}
                            chooseLabel="Adjuntar Documentación"
                            className="p-button-outlined p-button-secondary w-full"
                            onSelect={fotosUpoladLicencia}
                            onClear={() => setLicenciaFile(null)}
                            multiple={true}
                            // CAMBIO AQUÍ: Agregamos PDF y Office
                            accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx"
                        />
                    </div>
                    <div className="col-6 mt-2">
                        <CapturaFotosEmpleado funcFoto={fotosCamaraLicencia} />
                    </div>

                    <div className="col-12 flex justify-content-end gap-2 mt-3">
                        <Button
                            label="Cancelar"
                            className="p-button-text"
                            onClick={() => setLicenciaDialog(false)}
                        />
                        <Button
                            label="Guardar"
                            icon="pi pi-save"
                            onClick={guardaLicencia}
                            loading={licenciaLoading}
                        />
                    </div>
                </div>
            </Dialog>

            {/* 3. LIBRETAS */}
            <Dialog
                header="Libreta Militar"
                visible={modals.libreta}
                style={{ width: '850px' }}
                onHide={() => toggleModal('libreta', false)}
            >
                <div className="flex justify-content-end mb-3">
                    <Button
                        label="Nuevo"
                        icon="pi pi-plus"
                        className="p-button-primary"
                        onClick={openNewLibreta}
                    />
                </div>

                <DataTable
                    value={libretas}
                    size="small"
                    showGridlines
                    emptyMessage="No hay libretas registradas."
                >
                    {/* 1. TIPO (Muestra el nombre de la categoría en lugar del ID) */}
                    <Column
                        header="Tipo"
                        body={(r) => {
                            const cat = listas.categoriasLibreta.find(
                                (c) => c.configuracionDetId === r.categoria
                            );
                            return cat ? cat.nombre : '...';
                        }}
                        style={{ width: '20%' }}
                    />

                    {/* 2. NÚMERO */}
                    <Column field="numero" header="Número" />

                    {/* 3. FECHAS (Formateadas) */}
                    <Column
                        field="fechaIngreso"
                        header="Desde"
                        body={(r) =>
                            r.fechaIngreso ? new Date(r.fechaIngreso).toLocaleDateString() : ''
                        }
                    />

                    <Column
                        field="fechaFin"
                        header="Hasta"
                        body={(r) => (r.fechaFin ? new Date(r.fechaFin).toLocaleDateString() : '')}
                    />

                    {/* 4. ARCHIVO (Botón Ver - Reutilizando archivoBodyTemplate) */}
                    <Column
                        header="Archivo"
                        body={archivoBodyTemplate}
                        style={{ width: '80px', textAlign: 'center' }}
                    />

                    {/* 5. ACCIONES (Eliminar) */}
                    <Column
                        header="Acciones"
                        body={(r) => (
                            <div className="flex gap-2 justify-content-center">
                                <Button
                                    icon="pi pi-pencil"
                                    className="p-button-rounded p-button-text p-button-warning"
                                    onClick={() => openEditLibreta(r)}
                                    tooltip="Editar Libreta"
                                />
                                <Button
                                    icon="pi pi-trash"
                                    className="p-button-rounded p-button-text p-button-danger"
                                    onClick={() => deleteLibreta(r)}
                                />
                            </div>
                        )}
                        style={{ width: '80px', textAlign: 'center' }}
                    />
                </DataTable>
            </Dialog>

            {/* 3.1 FORM LIBRETA */}
            <Dialog
                header="Nueva Libreta"
                visible={libretaDialog}
                style={{ width: '500px' }}
                modal
                onHide={() => setLibretaDialog(false)}
            >
                <div className="p-fluid formgrid grid">
                    {/* 2.b. NUEVA LIBRETA CATEGORIA CON BOTÓN */}
                    <div className="field col-12 md:col-6">
                        <label>Categoría</label>
                        <div className="p-inputgroup">
                            <Dropdown
                                value={libretaData.categoriaId}
                                // CAMBIO: Usar listas.categoriasLibreta
                                options={listas.categoriasLibreta}
                                optionLabel="nombre"
                                optionValue="configuracionDetId"
                                onChange={(e) => onLibretaChange(e.value, 'categoriaId')}
                                placeholder="Seleccione"
                            />
                            <Button
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={() => handleAddConfig('CATEGORIA_LIBRETA')}
                            />
                        </div>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label>Número</label>
                        <InputText
                            value={libretaData.numero}
                            onChange={(e) => onLibretaChange(e.target.value, 'numero')}
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label>Fecha Ingreso</label>
                        <Calendar
                            value={libretaData.fechaIngreso}
                            onChange={(e) => onLibretaChange(e.value, 'fechaIngreso')}
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label>Fecha Fin</label>
                        <Calendar
                            value={libretaData.fechaFin}
                            onChange={(e) => onLibretaChange(e.value, 'fechaFin')}
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>

                    {/* 1. ADJUNTAR EN LIBRETA */}
                    <div className="col-6 mt-2">
                        <FileUpload
                            mode="basic"
                            name="archivos"
                            chooseLabel="Adjuntar Libreta"
                            accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx"
                            maxFileSize={5000000}
                            auto={false}
                            onSelect={fotosUploadLibreta}
                            onClear={() => setLibretaFile(null)}
                            multiple={true}
                            className="p-button-outlined p-button-secondary w-full"
                        />
                    </div>
                    <div className="col-6 mt-2">
                        <CapturaFotosEmpleado funcFoto={fotosCamaraLibreta} />
                    </div>

                    <div className="col-12 flex justify-content-end gap-2 mt-3">
                        <Button
                            label="Cancelar"
                            className="p-button-text"
                            onClick={() => setLibretaDialog(false)}
                        />
                        <Button
                            label="Guardar"
                            icon="pi pi-save"
                            onClick={guardaLibreta}
                            loading={procLibreta}
                        />
                    </div>
                </div>
            </Dialog>

            {/* 4. TELÉFONOS */}
            <Dialog
                header="Teléfonos"
                visible={modals.telefonos}
                style={{ width: '800px' }}
                onHide={() => toggleModal('telefonos', false)}
            >
                <div className="flex justify-content-end mb-3">
                    <Button
                        label="Nuevo"
                        icon="pi pi-plus"
                        className="p-button-primary"
                        onClick={openNewPhone}
                    />
                </div>
                <DataTable
                    value={phones}
                    size="small"
                    showGridlines
                    emptyMessage="No hay registros"
                >
                    {/* Usamos el template 'tipoTelefonoTemplate' que ya tienes definido arriba */}
                    <Column header="Tipo" body={tipoTelefonoTemplate} style={{ width: '20%' }} />
                    <Column field="numero" header="Número" />
                    <Column field="referencia" header="Referencia" />
                    <Column
                        header="Principal"
                        body={principalPhoneTemplate}
                        style={{ width: '10%' }}
                        className="text-center"
                    />

                    <Column
                        header="Acciones"
                        body={(r) => (
                            <div className="flex gap-2 justify-content-center">
                                <Button
                                    icon="pi pi-pencil"
                                    className="p-button-rounded p-button-text p-button-warning"
                                    onClick={() => openEditPhone(r)}
                                />
                                <Button
                                    icon="pi pi-trash"
                                    className="p-button-rounded p-button-text p-button-danger"
                                    onClick={() => deletePhone(r)}
                                />
                            </div>
                        )}
                        style={{ width: '100px', textAlign: 'center' }}
                    />
                </DataTable>
            </Dialog>

            {/* 4.1 FORM TELÉFONO */}
            <Dialog
                header={phoneData.id ? 'Editar Teléfono' : 'Nuevo Teléfono'}
                visible={phoneDialog}
                style={{ width: '450px' }}
                modal
                onHide={() => setPhoneDialog(false)}
                className="p-fluid"
            >
                {/* 1. TIPO (Dropdown) */}
                <div className="field">
                    <label htmlFor="tipoTel">Tipo Teléfono</label>
                    <div className="p-inputgroup">
                        <Dropdown
                            id="tipoTel"
                            value={phoneData.tipo}
                            options={listas.tiposTelefono} // Esta lista viene de useEmpleados
                            onChange={(e) => setPhoneData({ ...phoneData, tipo: e.value })}
                            optionLabel="nombre"
                            optionValue="configuracionDetId"
                            placeholder="Seleccione"
                            className={submitted && !phoneData.tipo ? 'p-invalid w-full' : 'w-full'}
                        />
                        {/* Botón para agregar config al vuelo */}
                        <Button
                            icon="pi pi-plus"
                            className="p-button-success"
                            onClick={() => handleAddConfig('TIPO_TELEFONO')}
                        />
                    </div>
                    {submitted && !phoneData.tipo && <small className="p-error">Requerido.</small>}
                </div>

                {/* 2. NÚMERO (Input) */}
                <div className="field">
                    <label>Número</label>
                    <InputText
                        value={phoneData.numero}
                        onChange={(e) => setPhoneData({ ...phoneData, numero: e.target.value })}
                        className={submitted && !phoneData.numero ? 'p-invalid' : ''}
                    />
                    {submitted && !phoneData.numero && (
                        <small className="p-error">El número es obligatorio.</small>
                    )}
                </div>

                {/* 3. REFERENCIA (Input) */}
                <div className="field">
                    <label>Referencia</label>
                    <InputText
                        value={phoneData.referencia}
                        onChange={(e) => setPhoneData({ ...phoneData, referencia: e.target.value })}
                    />
                </div>

                <div className="flex justify-content-end gap-2 mt-4">
                    <Button
                        label="Cancelar"
                        className="p-button-text"
                        onClick={() => setPhoneDialog(false)}
                    />
                    {/* El botón llama a savePhone, que valida los datos antes de enviar */}
                    <Button
                        label="Guardar"
                        icon="pi pi-save"
                        onClick={savePhone}
                        loading={phoneLoading}
                        disabled={phoneLoading}
                    />
                </div>
            </Dialog>

            {/* 6. EDUCACIÓN (LISTA) */}
            <Dialog
                header="Educación"
                visible={modals.educacion}
                style={{ width: '900px' }}
                onHide={() => toggleModal('educacion', false)}
            >
                {/* 1. CORRECCIÓN: Agregado el onClick para abrir el formulario */}
                <div className="flex justify-content-end mb-3">
                    <Button
                        label="Nuevo"
                        onClick={openNewEducacion}
                        icon="pi pi-plus"
                        className="p-button-primary"
                    />
                </div>

                <DataTable
                    value={educacionList}
                    size="small"
                    showGridlines
                    emptyMessage="No hay registros educativos."
                >
                    <Column
                        header="Nivel"
                        body={(r) => {
                            // 2. CORRECCIÓN: Aseguramos que lea de 'listas'
                            const cat = listas.nivelesEducacion.find(
                                (c) => c.configuracionDetId === r.categoria
                            );
                            return cat ? cat.nombre : '...';
                        }}
                    />

                    <Column field="institucion" header="Institución" />
                    <Column field="titulo_nombre" header="Título" />

                    <Column
                        header="Inicio"
                        body={(r) =>
                            r.fechaInicio ? new Date(r.fechaInicio).toLocaleDateString() : ''
                        }
                    />
                    <Column
                        header="Fin"
                        body={(r) => (r.fechaFin ? new Date(r.fechaFin).toLocaleDateString() : '')}
                    />

                    <Column
                        header="Archivo"
                        body={archivoBodyTemplate}
                        style={{ width: '70px', textAlign: 'center' }}
                    />

                    <Column
                        header="Acciones"
                        body={(r) => (
                            <div className="flex gap-2 justify-content-center">
                                <Button
                                    icon="pi pi-pencil"
                                    className="p-button-rounded p-button-text p-button-warning"
                                    onClick={() => openEditEducacion(r)}
                                    tooltip="Editar Educación"
                                />
                                <Button
                                    icon="pi pi-trash"
                                    className="p-button-rounded p-button-text p-button-danger"
                                    onClick={() => deleteEducacion(r)}
                                />
                            </div>
                        )}
                        style={{ width: '70px', textAlign: 'center' }}
                    />
                </DataTable>
            </Dialog>

            {/* 7. FORM EDUCACIÓN (EDICIÓN/CREACIÓN) */}
            <Dialog
                header={educacionData.id ? 'Editar Educación' : 'Adición de educación'}
                // 3. CORRECCIÓN: Usar 'educacionDialog', NO 'accountDialog'
                visible={educacionDialog}
                style={{ width: '600px' }}
                // 4. CORRECCIÓN: Setter correcto
                onHide={() => setEducacionDialog(false)}
                modal
            >
                <div className="p-fluid formgrid grid">
                    <div className="field col-12">
                        <label className="font-bold">Tipo: Educación Formal</label>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label className="">Categoría *</label>
                        <div className="p-inputgroup">
                            <Dropdown
                                value={educacionData.categoriaId}
                                // 5. CORRECCIÓN: Usar la lista global 'listas.nivelesEducacion'
                                options={listas.nivelesEducacion}
                                optionLabel="nombre"
                                optionValue="configuracionDetId"
                                onChange={(e) =>
                                    setEducacionData({ ...educacionData, categoriaId: e.value })
                                }
                                placeholder="Seleccione Nivel"
                                className="w-full"
                            />

                            <Button
                                icon="pi pi-plus"
                                className="p-button-success"
                                // 6. CORRECCIÓN: Clave correcta según tu useEmpleados
                                onClick={() => handleAddConfig('CATEGORIA_EDUCACION')}
                                tooltip="Agregar nueva categoría"
                                tooltipOptions={{ position: 'top' }}
                            />
                        </div>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label className="">Institución *</label>
                        <InputText
                            value={educacionData.institucion || ''}
                            onChange={(e) =>
                                setEducacionData({ ...educacionData, institucion: e.target.value })
                            }
                            placeholder="Ej: Universidad Central"
                        />
                    </div>

                    <div className="field col-12 md:col-12">
                        <label>Título / Descripción</label>
                        <InputText
                            value={educacionData.titulo_nombre || ''}
                            onChange={(e) =>
                                setEducacionData({
                                    ...educacionData,
                                    titulo_nombre: e.target.value
                                })
                            }
                            placeholder="Ej: Ingeniero en Sistemas"
                        />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label>Fecha Inicio</label>
                        <Calendar
                            value={educacionData.fecha_inicio}
                            onChange={(e) =>
                                setEducacionData({ ...educacionData, fecha_inicio: e.value })
                            }
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label>Fecha Fin</label>
                        <Calendar
                            value={educacionData.fecha_fin}
                            onChange={(e) =>
                                setEducacionData({ ...educacionData, fecha_fin: e.value })
                            }
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>

                    <div className="field col-6">
                        <label className="">Documento de Respaldo *</label>
                        <FileUpload
                            mode="basic"
                            name="archivos"
                            accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx"
                            maxFileSize={5000000}
                            chooseLabel="Seleccionar Archivo"
                            auto={false}
                            onSelect={fotosUploadEducacion}
                            onClear={() => setEducacionFile(null)}
                            multiple={true}
                        />
                    </div>
                    <div className="col-6 mt-2">
                        <label style={{ visibility: 'hidden' }}>Este texto no se ve</label>
                        <CapturaFotosEmpleado funcFoto={fotosCamaraEducacion} />
                    </div>

                    <div className="col-12 flex justify-content-end mt-3">
                        <Button
                            label="Guardar"
                            icon="pi pi-save"
                            onClick={guardaEducacion}
                            loading={guardandoEdu}
                            disabled={educacionLoading}
                        />
                    </div>
                </div>
            </Dialog>

            {/* 8. CUENTAS BANCARIAS */}
            <Dialog
                header="Cuentas Bancarias"
                visible={modals.cuentas}
                style={{ width: '900px' }}
                onHide={() => toggleModal('cuentas', false)}
            >
                <div className="flex justify-content-end mb-3">
                    <Button
                        label="Adicionar"
                        icon="pi pi-plus"
                        onClick={openNewAccount}
                        className="p-button-primary p-button-sm"
                    />
                </div>
                <DataTable
                    value={accounts}
                    size="small"
                    showGridlines
                    emptyMessage="No hay cuentas."
                >
                    <Column field="numeroCuenta" header="Número" />
                    <Column header="Banco" body={bancoTemplate} />
                    <Column header="Tipo" body={tipoCuentaTemplate} />

                    {/*<Column header="Principal" body={r => r.esPrincipal ? <i className="pi pi-check text-green-500 font-bold"></i> : ''} className="text-center" />*/}

                    <Column
                        header="Principal"
                        body={principalAccountTemplate}
                        style={{ width: '10%' }}
                        className="text-center"
                    />

                    <Column
                        header="Acciones"
                        body={(rowData) => (
                            <div className="flex gap-2 justify-content-center">
                                <Button
                                    icon="pi pi-pencil"
                                    className="p-button-rounded p-button-text p-button-warning"
                                    onClick={() => openEditAccount(rowData)}
                                />
                                <Button
                                    icon="pi pi-trash"
                                    className="p-button-rounded p-button-text p-button-danger"
                                    onClick={() => deleteAccount(rowData)}
                                />
                            </div>
                        )}
                    />
                </DataTable>
            </Dialog>

            {/* 9. FORM CUENTAS */}
            <Dialog
                header={accountData.id ? 'Editar Cuenta' : 'Nueva Cuenta'}
                visible={accountDialog}
                style={{ width: '500px' }}
                modal
                onHide={() => setAccountDialog(false)}
            >
                <div className="p-fluid formgrid grid">
                    <div className="field col-12">
                        <label>Número</label>
                        <InputText
                            value={accountData.numeroCuenta}
                            onChange={(e) =>
                                setAccountData({ ...accountData, numeroCuenta: e.target.value })
                            }
                        />
                    </div>

                    {/* 2.c. NUEVA CUENTA BANCO Y TIPO CON BOTONES */}
                    <div className="field col-12 md:col-6">
                        <label>Banco</label>
                        <div className="p-inputgroup">
                            <Dropdown
                                value={accountData.bancoId}
                                options={listas.bancos}
                                onChange={(e) => setAccountData({ ...accountData, bancoId: e.value })}
                                optionLabel="nombre"
                                optionValue="configuracionDetId"
                                placeholder="Seleccione"
                            />
                            <Button
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={() => handleAddConfig('BANCOS')}
                            />
                        </div>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label>Tipo</label>
                        <div className="p-inputgroup">
                            <Dropdown
                                value={accountData.tipoCuentaId}
                                options={listas.tiposCuenta}
                                onChange={(e) =>
                                    setAccountData({ ...accountData, tipoCuentaId: e.value })
                                }
                                optionLabel="nombre"
                                optionValue="configuracionDetId"
                                placeholder="Seleccione"
                            />
                            <Button
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={() => handleAddConfig('TIPO_CUENTA')}
                            />
                        </div>
                    </div>

                    <div className="col-12 flex justify-content-end gap-2 mt-3">
                        <Button
                            label="Cancelar"
                            className="p-button-text"
                            onClick={() => setAccountDialog(false)}
                        />
                        <Button
                            label="Guardar"
                            icon="pi pi-save"
                            onClick={saveAccount}
                            loading={accountLoading}
                            disabled={accountLoading}
                        />
                    </div>
                </div>
            </Dialog>

            {/* 10. HISTORIAL */}
            <Dialog
                header="Historial"
                visible={modals.historial}
                style={{ width: '800px' }}
                onHide={() => toggleModal('historial', false)}
            >
                <div className="flex justify-content-end mb-3">
                    <Button
                        label="Nuevo"
                        icon="pi pi-plus"
                        onClick={openNewHistorial}
                        className="p-button-primary"
                    />
                </div>

                <DataTable
                    value={historialList}
                    size="small"
                    showGridlines
                    emptyMessage="Sin historial."
                >
                    {/* Tipo */}
                    <Column
                        header="Tipo"
                        body={(r) => {
                            const t = listas.tiposHistorial.find(
                                (c) => c.configuracionDetId === r.tipo
                            );
                            return t ? t.nombre : '...';
                        }}
                    />

                    <Column field="numero" header="Ref/Memo" />
                    <Column field="observaciones" header="Detalle" />
                    <Column
                        header="Fecha de Registro"
                        body={(r) =>
                            r.fechaEmision ? new Date(r.fechaEmision).toLocaleDateString() : ''
                        }
                    />

                    <Column
                        header="Archivo"
                        body={archivoBodyTemplate}
                        style={{ width: '70px', textAlign: 'center' }}
                    />

                    <Column
                        header="Acciones"
                        body={(r) => (
                            <div className="flex gap-2 justify-content-center">
                                <Button
                                    icon="pi pi-pencil"
                                    className="p-button-rounded p-button-warning p-button-text"
                                    onClick={() => openEditHistorial(r)}
                                    tooltip="Editar Empleado"
                                />
                                <Button
                                    icon="pi pi-trash"
                                    className="p-button-rounded p-button-text p-button-danger"
                                    onClick={() => deleteHistorial(r)}
                                />
                            </div>
                        )}
                        style={{ width: '70px', textAlign: 'center' }}
                    />
                </DataTable>
            </Dialog>

            {/* 11. FORM HISTORIAL */}
            <Dialog
                header={historialData.id ? 'Editar Historial' : 'Nuevo Historial'}
                visible={historialDialog}
                style={{ width: '600px' }}
                onHide={() => setHistorialDialog(false)}
                modal
            >
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label className="font-bold">Tipo</label>
                        <div className="p-inputgroup">
                            <Dropdown
                                value={historialData.tipoId}
                                options={listas.tiposHistorial}
                                optionLabel="nombre"
                                optionValue="configuracionDetId"
                                onChange={(e) =>
                                    setHistorialData({ ...historialData, tipoId: e.value })
                                }
                                placeholder="Seleccione"
                            />
                            <Button
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={() => handleAddConfig('TIPO_HISTORIAL')}
                            />
                        </div>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label className="font-bold">Numero (Ref/Memo)</label>
                        <InputText
                            value={historialData.numero || ''}
                            onChange={(e) =>
                                setHistorialData({ ...historialData, numero: e.target.value })
                            }
                            placeholder="Ej: MEMO-2024-001"
                        />
                    </div>

                    <div className="field col-12">
                        <label className="font-bold">Observaciones (Detalle)</label>
                        <InputText
                            value={historialData.observaciones || ''}
                            onChange={(e) =>
                                setHistorialData({
                                    ...historialData,
                                    observaciones: e.target.value
                                })
                            }
                            placeholder="Detalles de la sanción o felicitación"
                        />
                    </div>

                    {/* ITEM 7: FECHA CREACIÓN (AUTOMÁTICA Y SOLO LECTURA)  */}
                    <div className="field col-12">
                        <label className="font-bold">Fecha de Emisión</label>
                        <Calendar
                            value={historialData.fechaEmision}
                            onChange={(e) =>
                                setHistorialData({ ...historialData, fechaEmision: e.value })
                            }
                            showIcon
                            dateFormat="dd/mm/yy"
                            placeholder="Seleccione la fecha del documento"
                            className="w-full"
                        />
                    </div>

                    {/* ITEM 8: RANGO DE FECHAS (INICIO Y FIN)  */}
                    <div className="field col-12 md:col-6">
                        <label className="font-bold">Fecha Inicio</label>
                        <Calendar
                            value={historialData.fecha_inicio}
                            onChange={(e) =>
                                setHistorialData({ ...historialData, fecha_inicio: e.value })
                            }
                            showIcon
                            dateFormat="dd/mm/yy"
                            placeholder="dd/mm/aaaa"
                        />
                    </div>

                    <div className="field col-12 md:col-6">
                        <label className="font-bold">Fecha Fin</label>
                        <Calendar
                            value={historialData.fecha_fin}
                            onChange={(e) =>
                                setHistorialData({ ...historialData, fecha_fin: e.value })
                            }
                            showIcon
                            dateFormat="dd/mm/yy"
                            minDate={historialData.fecha_inicio} // Validación básica
                            placeholder="dd/mm/aaaa"
                        />
                    </div>

                    <div className="col-6 mt-2">
                        <FileUpload
                            mode="basic"
                            chooseLabel="Adjuntar Documento"
                            className="p-button-info w-auto"
                            onSelect={fotosUploadHistorial}
                            onClear={() => setHistorialFile(null)}
                            multiple={true}
                            accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx"
                        />
                    </div>
                    <div className="col-6 mt-2">
                        <CapturaFotosEmpleado funcFoto={fotosCamaraHistorial} />
                    </div>

                    <div className="col-12 flex justify-content-end mt-4">
                        <Button
                            label="Guardar Historial"
                            icon="pi pi-save"
                            className="p-button-primary w-auto shadow-2"
                            onClick={guardaHistorial}
                            loading={grabaHistorial}
                        />
                    </div>
                </div>
            </Dialog>

            {/* 12. FAMILIAR */}
            <Dialog
                header="Información Familiar"
                visible={modals.familia}
                style={{ width: '900px' }}
                onHide={() => toggleModal('familia', false)}
            >
                <div className="flex justify-content-end mb-3">
                    <Button
                        label="Nuevo"
                        icon="pi pi-plus"
                        onClick={openNewFamiliar}
                        className="p-button-primary"
                    />
                </div>
                <DataTable
                    value={familiares}
                    size="small"
                    showGridlines
                    emptyMessage="No hay familiares."
                >
                    <Column field="nombre" header="Nombre" style={{ width: '25%' }} />

                    <Column
                        header="Parentesco"
                        body={parentescoTemplate}
                        style={{ width: '20%' }}
                    />

                    {/* COLUMNA NUEVA: CARGA FAMILIAR */}
                    <Column
                        header="¿Es Carga?"
                        body={(r) => (
                            <div className="text-center">
                                {r.esCargaFamiliar ? (
                                    <span className="p-tag p-tag-success font-bold px-3">SÍ</span>
                                ) : (
                                    <span className="p-tag p-tag-secondary opacity-60 px-3">
                                        NO
                                    </span>
                                )}
                            </div>
                        )}
                        style={{ width: '110px' }}
                    />

                    <Column field="identificador" header="Nro. Doc" style={{ width: '20%' }} />

                    <Column
                        header="Acciones"
                        body={(rowData) => (
                            <div className="flex gap-2 justify-content-center">
                                <Button
                                    icon="pi pi-pencil"
                                    className="p-button-text p-button-warning"
                                    onClick={() => openEditFamiliar(rowData)}
                                />
                                <Button
                                    icon="pi pi-trash"
                                    className="p-button-text p-button-danger"
                                    onClick={() => deleteFamiliar(rowData)}
                                />
                            </div>
                        )}
                        style={{ width: '15%' }}
                    />
                </DataTable>
            </Dialog>

            {/* 13. FORM FAMILIA */}
            <Dialog
                header={familiarData.id ? 'Editar' : 'Nuevo'}
                visible={familyDialog}
                style={{ width: '700px' }}
                modal
                onHide={() => setFamilyDialog(false)}
            >
                <div className="p-fluid formgrid grid align-items-end">
                    <div className="field col-12 md:col-6">
                        <label>Nombre</label>
                        <InputText
                            value={familiarData.nombre}
                            onChange={(e) =>
                                setFamiliarData({ ...familiarData, nombre: e.target.value })
                            }
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label>Fecha Nacimiento</label>
                        <Calendar
                            value={familiarData.fechaNacimiento}
                            onChange={(e) =>
                                setFamiliarData({ ...familiarData, fechaNacimiento: e.value })
                            }
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>

                    {/* 2.d. NUEVO FAMILIAR TIPO GRUPO Y PARENTESCO CON BOTONES */}
                    <div className="field col-12 md:col-6">
                        <label>Tipo Grupo</label>
                        <div className="p-inputgroup">
                            <Dropdown
                                value={familiarData.tipoFamiliarId}
                                options={listas.tiposFamilia}
                                onChange={(e) =>
                                    setFamiliarData({ ...familiarData, tipoFamiliarId: e.value })
                                }
                                optionLabel="nombre"
                                optionValue="configuracionDetId"
                                placeholder="Seleccione"
                            />
                            <Button
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={() => handleAddConfig('TIPO_GRUPO_FAMILIAR')}
                            />
                        </div>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label>Parentesco</label>
                        <div className="p-inputgroup">
                            <Dropdown
                                value={familiarData.parentescoId}
                                options={listas.parentescos}
                                onChange={(e) =>
                                    setFamiliarData({ ...familiarData, parentescoId: e.value })
                                }
                                optionLabel="nombre"
                                optionValue="configuracionDetId"
                                placeholder="Seleccione"
                            />
                            <Button
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={() => handleAddConfig('PARENTESCO')}
                            />
                        </div>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label>Tipo Doc</label>
                        <div className="p-inputgroup">
                            <Dropdown
                                value={familiarData.tipoDoc}
                                options={listas.tiposDocumento}
                                onChange={(e) =>
                                    setFamiliarData({ ...familiarData, tipoDoc: e.value })
                                }
                                optionLabel="nombre"
                                optionValue="configuracionDetId"
                                placeholder="Seleccione"
                            />
                            {/* También agregué el botón aquí por consistencia con el form principal */}
                            <Button
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={() => handleAddConfig('TIPO_DOCUMENTO')}
                            />
                        </div>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label>Nro. Doc</label>
                        <InputText
                            value={familiarData.identificador}
                            onChange={(e) =>
                                setFamiliarData({ ...familiarData, identificador: e.target.value })
                            }
                        />
                    </div>
                    {/*es_carga_familiar input checkbox */}
                    <div className="field col-12 md:col-6 flex flex-column justify-content-center">
                        <label>¿Es Carga Familiar?</label>
                        <div className="flex align-items-center gap-4 h-3rem    ">
                            <div className="flex align-items-center">
                                <RadioButton
                                    inputId="cargaSi"
                                    name="esCargaFamiliar"
                                    value={true}
                                    onChange={(e) =>
                                        setFamiliarData({
                                            ...familiarData,
                                            esCargaFamiliar: e.value
                                        })
                                    }
                                    checked={familiarData.esCargaFamiliar === true}
                                />
                                <label htmlFor="cargaSi" className="ml-2">
                                    Sí
                                </label>
                            </div>
                            <div className="flex align-items-center">
                                <RadioButton
                                    inputId="cargaNo"
                                    name="esCargaFamiliar"
                                    value={false}
                                    onChange={(e) =>
                                        setFamiliarData({
                                            ...familiarData,
                                            esCargaFamiliar: e.value
                                        })
                                    }
                                    checked={familiarData.esCargaFamiliar === false}
                                />
                                <label htmlFor="cargaNo" className="ml-2">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="field col-12 md:col-6 flex flex-column justify-content-center">
                        <label>¿Aplica Utilidad?</label>
                        <div className="flex align-items-center gap-4 h-3rem    ">
                            <div className="flex align-items-center">
                                <RadioButton
                                    inputId="utilidadSi"
                                    name="aplicaUtilidad"
                                    value={true}
                                    onChange={(e) =>
                                        setFamiliarData({
                                            ...familiarData,
                                            aplicaUtilidad: e.value
                                        })
                                    }
                                    checked={familiarData.aplicaUtilidad === true}
                                />
                                <label htmlFor="utilidadSi" className="ml-2">
                                    Sí
                                </label>
                            </div>
                            <div className="flex align-items-center">
                                <RadioButton
                                    inputId="utilidadNo"
                                    name="aplicaUtilidad"
                                    value={false}
                                    onChange={(e) =>
                                        setFamiliarData({
                                            ...familiarData,
                                            aplicaUtilidad: e.value
                                        })
                                    }
                                    checked={familiarData.aplicaUtilidad === false}
                                />
                                <label htmlFor="utilidadNo" className="ml-2">
                                    No
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 flex justify-content-end gap-2 mt-4">
                        <Button
                            label="Cancelar"
                            className="p-button-text"
                            onClick={() => toggleModal('addFamilia', false)}
                        />
                        <Button
                            icon="pi pi-save"
                            label="Guardar"
                            onClick={saveFamiliar}
                            loading={familiarLoading}
                            disabled={familiarLoading}
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header="Otros Documentos"
                visible={modals.otrosDocs}
                style={{ width: '800px' }}
                onHide={() => toggleModal('otrosDocs', false)}
            >
                <div className="flex justify-content-end mb-3">
                    <Button
                        label="Nuevo"
                        icon="pi pi-plus"
                        onClick={openNewOtrosDocs}
                        className="p-button-primary"
                    />
                </div>

                <DataTable
                    value={otrosDocsList}
                    size="small"
                    showGridlines
                    emptyMessage="No hay documentos."
                >
                    <Column header="Categoría" body={otrosDocsCatTemplate} />

                    <Column field="numero" header="Número" />

                    <Column
                        header="Fecha"
                        body={(r) =>
                            r.fecha_inicio ? new Date(r.fecha_inicio).toLocaleDateString() : ''
                        }
                    />

                    <Column
                        header="Archivo"
                        body={archivoBodyTemplate}
                        style={{ width: '70px', textAlign: 'center' }}
                    />

                    <Column
                        header="Acciones"
                        body={(r) => (
                            <div className="flex gap-2 justify-content-center">
                                <Button
                                    icon="pi pi-pencil"
                                    className="p-button-rounded p-button-text p-button-warning"
                                    onClick={() => openEditOtrosDocs(r)}
                                    tooltip="Editar"
                                />
                                <Button
                                    icon="pi pi-trash"
                                    className="p-button-rounded p-button-text p-button-danger"
                                    onClick={() => deleteOtrosDocs(r)}
                                />
                            </div>
                        )}
                        style={{ width: '70px', textAlign: 'center' }}
                    />
                </DataTable>
            </Dialog>

            {/* 15. FORM OTROS DOCS */}
            <Dialog
                header="Adición de otros documentos"
                visible={otrosDocsDialog}
                style={{ width: '600px' }}
                onHide={() => setOtrosDocsDialog(false)}
                modal
            >
                <div className="p-fluid formgrid grid">
                    <div className="field col-12 md:col-6">
                        <label>Categoría</label>
                        <div className="p-inputgroup">
                            <Dropdown
                                value={otrosDocsData.categoriaId}
                                options={listas.tiposOtrosDocs}
                                optionLabel="nombre"
                                optionValue="configuracionDetId"
                                onChange={(e) =>
                                    setOtrosDocsData({ ...otrosDocsData, categoriaId: e.value })
                                }
                                placeholder="Seleccione"
                            />
                            <Button
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={() => handleAddConfig('TIPO_OTROS_DOCS')}
                            />
                        </div>
                    </div>

                    {/* CAMPO NUMERO CONECTADO */}
                    <div className="field col-12 md:col-6">
                        <label>Numero</label>
                        <InputText
                            value={otrosDocsData.numero || ''}
                            onChange={(e) =>
                                setOtrosDocsData({ ...otrosDocsData, numero: e.target.value })
                            }
                        />
                    </div>

                    {/* FECHAS CONECTADAS */}
                    {/* FECHA INICIO (Emisión) */}
                    <div className="field col-12 md:col-6">
                        <label className="font-bold">Fecha de Emisión</label>
                        <Calendar
                            value={otrosDocsData.fecha_inicio}
                            onChange={(e) =>
                                setOtrosDocsData({ ...otrosDocsData, fecha_inicio: e.value })
                            }
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>

                    {/* FECHA FIN (Expiración) */}
                    <div className="field col-12 md:col-6">
                        <label className="font-bold">Fecha de Expiración</label>
                        <Calendar
                            value={otrosDocsData.fecha_fin}
                            onChange={(e) =>
                                setOtrosDocsData({ ...otrosDocsData, fecha_fin: e.value })
                            }
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>

                    {/* DESCRIPCION (Faltaba en tu código visual) */}
                    <div className="field col-12">
                        <label>Descripción / Observaciones</label>
                        <InputText
                            value={otrosDocsData.descripcion || ''}
                            onChange={(e) =>
                                setOtrosDocsData({ ...otrosDocsData, descripcion: e.target.value })
                            }
                        />
                    </div>

                    <div className="col-6 mt-3">
                        <FileUpload
                            mode="basic"
                            name="archivos"
                            auto={false}
                            chooseLabel="Adjuntar archivo"
                            className="p-button-info w-auto"
                            onSelect={fotosUploadOtrosDocs}
                            onClear={() => setOtrosDocsFile(null)}
                            multiple={true}
                            accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx"
                        />
                    </div>
                    <div className="col-6 mt-2">
                        <CapturaFotosEmpleado funcFoto={fotosCamaraOtrosDocs} />
                    </div>

                    <div className="col-12 flex justify-content-end mt-3">
                        <Button
                            label="Guardar"
                            className="p-button-primary w-auto"
                            onClick={guardaOtrosDocs}
                            loading={procesaOtrosDocs}
                        />
                    </div>
                </div>
            </Dialog>

            {/* 1. LISTADO DE FOTOS (GALERÍA) */}
            <Dialog
                header="Galería de Fotos"
                visible={fotosDialog}
                style={{ width: '900px' }}
                onHide={() => setFotosDialog(false)}
            >
                <div className="flex justify-content-end mb-3">
                    {/* Botón Nueva Foto: Usa openNewFoto (del hook), no toggleModal */}
                    <Button
                        label="Nueva Foto"
                        icon="pi pi-plus"
                        onClick={openNewFoto}
                        className="p-button-primary"
                    />
                </div>

                <DataTable
                    value={fotosList}
                    loading={fotosLoading}
                    size="small"
                    showGridlines
                    emptyMessage="No hay fotos en la galería."
                    responsiveLayout="stack"
                >
                    <Column
                        header="Miniatura"
                        body={(rowData) => (
                            <FotoThumbnail id={rowData.id} descripcion={rowData.descripcion} />
                        )}
                        style={{ width: '80px', textAlign: 'center' }}
                    />
                    <Column field="descripcion" header="Descripción / Título" />
                    <Column
                        header="Fecha"
                        body={(r) => (r.fecha ? new Date(r.fecha).toLocaleDateString() : '')}
                        style={{ width: '120px' }}
                    />
                    <Column
                        header="Archivo"
                        body={archivoBodyTemplate}
                        style={{ width: '100px', textAlign: 'center' }}
                    />
                    <Column
                        header="Acciones"
                        body={(r) => (
                            <div className="flex gap-2 justify-content-center">
                                {/* Usamos deleteFoto específico del hook */}
                                <Button
                                    icon="pi pi-trash"
                                    className="p-button-rounded p-button-text p-button-danger"
                                    onClick={() => deleteFoto(r)}
                                    tooltip="Eliminar Foto"
                                />
                            </div>
                        )}
                        style={{ width: '80px', textAlign: 'center' }}
                    />
                </DataTable>
            </Dialog>

            {/* 2. FORMULARIO DE SUBIDA (NUEVA FOTO) */}
            <Dialog
                header="Adicionar Foto"
                visible={addFotoDialog} // <--- CAMBIO: Variable para el FORMULARIO
                style={{ width: '450px' }}
                onHide={() => setAddFotoDialog(false)} // <--- Setter del formulario
                modal
            >
                <div className="p-fluid formgrid grid">
                    <div className="field col-12">
                        <label>Descripción / Título</label>
                        <InputText
                            value={fotoData.descripcion}
                            onChange={(e) =>
                                setFotoData({ ...fotoData, descripcion: e.target.value })
                            }
                        />
                    </div>
                    <div className="field col-12">
                        <label>Fecha de la Foto</label>
                        <Calendar
                            value={fotoData.fecha}
                            onChange={(e) => setFotoData({ ...fotoData, fecha: e.value })}
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>
                    <div className="col-6">
                        <FileUpload
                            mode="basic"
                            auto={false}
                            accept="image/*"
                            chooseLabel="Seleccionar Imagen"
                            onSelect={fotosUploadFotos}
                            onClear={() => setFotoFile(null)}
                            multiple={true}
                        />
                    </div>
                    <div className="col-6 mt-2">
                        <CapturaFotosEmpleado funcFoto={fotosCamaraFotos} />
                    </div>

                    <div className="col-12 flex justify-content-end mt-4">
                        <Button
                            label="Guardar"
                            icon="pi pi-save"
                            onClick={saveFoto}
                            loading={fotosLoading}
                            disabled={fotosLoading}
                        />
                    </div>
                </div>
            </Dialog>

            {/* 3. EXPERIENCIA LABORAL (LISTA) */}

            <Dialog
                header={experienciaData.id ? 'Editar Experiencia' : 'Nueva Experiencia'}
                visible={experienciaDialog}
                style={{ width: '600px' }}
                modal
                onHide={() => setExperienciaDialog(false)}
            >
                <div className="p-fluid formgrid grid">
                    <div className="field col-12">
                        <label className="font-bold">Empresa *</label>
                        <InputText
                            value={experienciaData.empresa}
                            onChange={(e) =>
                                setExperienciaData({ ...experienciaData, empresa: e.target.value })
                            }
                        />
                    </div>
                    <div className="field col-12">
                        <label className="font-bold">Proyecto</label>
                        <InputText
                            value={experienciaData.proyecto}
                            onChange={(e) =>
                                setExperienciaData({ ...experienciaData, proyecto: e.target.value })
                            }
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label className="font-bold">Fecha Ingreso</label>
                        <Calendar
                            value={experienciaData.fechaIngreso}
                            onChange={(e) =>
                                setExperienciaData({ ...experienciaData, fechaIngreso: e.value })
                            }
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label className="font-bold">Fecha Salida</label>
                        <Calendar
                            value={experienciaData.fechaSalida}
                            onChange={(e) =>
                                setExperienciaData({ ...experienciaData, fechaSalida: e.value })
                            }
                            showIcon
                            dateFormat="dd/mm/yy"
                        />
                    </div>
                    <div className="field col-12">
                        <label className="font-bold">Tiempo Experiencia:</label>
                        <InputText
                        value={experienciaData.tiempoExperiencia}
                        onChange={(e) =>
                                setExperienciaData({
                                    ...experienciaData,
                                    tiempoExperiencia: e.target.value
                                })
                            }
                        />
                    </div>
                    <div className="field col-12">
                        <label className="font-bold">Motivo de Salida</label>
                        <InputText
                            value={experienciaData.motivoSalida}
                            onChange={(e) =>
                                setExperienciaData({
                                    ...experienciaData,
                                    motivoSalida: e.target.value
                                })
                            }
                        />
                    </div>
                    <div className="col-12 flex justify-content-end gap-2 mt-3">
                        <Button
                            label="Cancelar"
                            className="p-button-text"
                            onClick={() => setExperienciaDialog(false)}
                        />
                        <Button
                            label="Guardar"
                            icon="pi pi-save"
                            onClick={saveExperiencia}
                            loading={experienciaLoading}
                        />
                    </div>
                </div>
            </Dialog>

            <Dialog
                header={visorTitle}
                visible={visorVisible}
                style={{ width: '50vw', minWidth: '350px' }}
                modal
                onHide={hideVisor}
                maximizable
                dismissableMask
                contentStyle={{ padding: '0', textAlign: 'center', backgroundColor: '#333' }}
            >
                {visorContent ? (
                    <div
                        className="flex justify-content-center align-items-center"
                        style={{ minHeight: '400px' }}
                    >
                        {/* Nota: Si usas PDF, cambia 'img' por 'iframe' o 'object' */}
                        <img
                            src={visorContent}
                            alt="Documento"
                            style={{
                                maxWidth: '100%',
                                maxHeight: '80vh',
                                objectFit: 'contain'
                            }}
                        />
                    </div>
                ) : (
                    <div className="flex align-items-center justify-content-center h-10rem text-white">
                        <i className="pi pi-spin pi-spinner text-4xl mr-2"></i> Cargando...
                    </div>
                )}
            </Dialog>
        </>
    );
}
